module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/connection-phone.caa9ca33.mp4";